module.exports = __webpack_public_path__ + "5bda2710554b202e3e69cf2ec4e0e663.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-BoldItalic.ttf
// module id = 1243
// module chunks = 0